export default {
  roleAdmin: '角色管理',
  roleList: '角色列表',
  roleCoding: '角色编码',
  roleName: '角色名称',
  roleId: '角色ID',
  selectroleId: '选择角色ID',
  creator: '创建人',
  Remarks: '备注',
  modiFicaTion: '修改',
  View: '查看',
  compileRole: '编辑角色',
  inputNull: '搜索不能为空',
  addRole: '添加角色',
  checkRole: '查看角色',
  deviceInfo: 'app账号依赖信息',

  data: {
    roleCode: '请输入角色编码',
    roleName: '请输入角色名称',
    distributedId: '请先选择分布式ID',
    addRoleError: '添加角色失败',
    changRoleError: '修改角色失败'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/rolemanager.js